import React, { useEffect, useState, useMemo } from 'react';
import { useSearchParams } from 'react-router-dom';

import { Tabs, Tab, Box } from 'vindi-ds-components';
import api from '@services/api';

import Table from './table';
import TableCard from './tableCard';

function TabsCustomerList({ setDescription, isMobile }) {
  const [metadata, setMetadata] = useState({});
  const [searchParams] = useSearchParams();

  const Component = useMemo(
    () => (isMobile ? TableCard : Table),
    [isMobile],
  );

  const tabs = useMemo(
    () => [
      {
        id: 1, label: 'Ativos', tagLabel: metadata.active?.toString(), tagKind: 'success', status: 'active',
      },
      {
        id: 2, label: 'Inativos', tagLabel: metadata.inactive?.toString(), tagKind: 'attention', status: 'inactive',
      },
      {
        id: 3, label: 'Inadimplentes', tagLabel: metadata.delinquent?.toString(), tagKind: 'warning', status: 'delinquent',
      },
      {
        id: 4, label: 'Arquivados', tagLabel: null, tagKind: null, status: 'archived',
      },
    ],
    [metadata],
  );

  useEffect(() => {
    api
      .get('/admin/customers')
      .then((response) => setMetadata(response.data.meta));
  }, []);

  return (
    <Box mt={2}>
      <Tabs>
        {tabs.map((tab) => (
          <Tab
            key={tab.id}
            label={tab.label}
            tagLabel={tab.tagLabel}
            tagKind={tab.tagKind}
            active={searchParams.get('status') === tab.status}
          >
            <Component
              key={tab.id}
              status={tab.status}
              setDescription={setDescription}
            />
          </Tab>
        ))}
      </Tabs>
    </Box>
  );
}

export default TabsCustomerList;
